import React,{useEffect, useState} from "react";
import Navbar from "./Navbar";
import axios from "axios";
import url from "../../function/url";
import Cookies from "js-cookie";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
function NewProductsPage() {
    const ID = Cookies.get("log_id");
    const user = Cookies.get("User");
    const [Products,setProducts] = useState([]);
    const [telecallers,setTelecallers] = useState([]);
    const [selectedProduct,setSelectedProduct] = useState(null);
    function NewProducts() {
        axios.get(`${url.path}/new_products/`)
        .then((res) =>{
            if(res.data.status){
                var prod = res.data.products;
                var tele = res.data.telecallers;
                setProducts([])
                prod.map((p)=>{
                    setProducts((prevState) =>[
                        ...prevState, p
                    ])
                })
                setTelecallers([])
                tele.map((t)=>{
                    setTelecallers((prevState) =>[
                        ...prevState, t
                    ])
                })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        NewProducts();
    }, [])
    const itemsPerPage = 3;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);

    const filteredData = Products.filter((item) =>
      item.Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
    };
    function searchTable(){
      var rows = document.querySelectorAll('#productstable tbody tr');
      var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
      rows.forEach(function(row) {
        var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
        row.style.display = text.includes(val) ? '' : 'none';
      });
    }
    const handleOpenModal = (cmp) => {
        setSelectedProduct(cmp);
      };
      const handleCloseModal = () => {
        setSelectedProduct(null);
      };
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
            },
        });
      const [telecaller,setTelecaller] = useState("");
      function handleSubmit(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('product',selectedProduct.id);
        formdata.append('telecaller',telecaller);
        axios.post(`${url.path}/assign_product/`,formdata)
        .then((res) =>{
            if (res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Product Assigned'
                })
                handleCloseModal();
                NewProducts();
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
      }
    return(
        <>
        <Navbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>New Products</h3>
            </center>
            <div className="search-container">
            <input
              type="text"
              placeholder="Search..."
              onKeyUp={searchTable}
              className="search-input"
              id="search"
            />
          </div>
        <div className="table-container">
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Price</th>
            <th>Contact</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {Products.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Name}</td>
              <td>{i.Price}</td>
              <td>{i.Contact}</td>
                <td><button type="button" style={{width:'80px',backgroundColor:'gainsboro',color:'black',borderRadius:'5px'}} onClick={() => handleOpenModal(i)}>Assign</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
    {selectedProduct && (
    <div className="modal-overlay" onClick={handleCloseModal}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-button"
          onClick={handleCloseModal}
        >
          &times;
        </button>
        <h2>Assign Telecaller</h2>
        <p>Are you sure to Assign {selectedProduct.Name}</p>
        <form onSubmit={handleSubmit}>
            <div className="from-group-row">
                <div className="form-group">
                    <label>Telecaller</label>
                    <select value={telecaller} onChange={(e) =>setTelecaller(e.target.value)}>
                        <option>--Select--</option>
                        {telecallers && telecallers.map((i)=>(
                            <option value={i.id}>{i.Employee_Name}</option>
                        ))}
                    </select>
                </div>

            </div>
          <center>
          <button type="submit" style={{width:'100px',backgroundColor:'gainsboro',borderRadius:'5px'}}>Assign</button>
          </center>
        </form>
      </div>
    </div>
  )}
        </>
    );
}
export default NewProductsPage;